import { AlkLogger } from '@alk/core';
import { ILimit } from '../../interfaces';
import { ILimitsService } from './limits.interface';
import { injectable } from 'inversify';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class LimitsMock implements ILimitsService {

    asObservable(): Observable<Array<ILimit>> {
        AlkLogger.info('[LimitsMock#asObservable]');

        return NEVER;
    }
}
